import { useState } from "react";
import {
  Button,
  Container,
  HStack,
  PinInput,
  PinInputField,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useLoaderData, useNavigate } from "react-router";

import { useVerifyLoginCode } from "~/lib/api/login.api";
import { saveLoginToken } from "~/lib/utils/local-storage.helpers";

export function VerifyToken() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyId } = useLoaderData<{ companyId: number }>();
  const [code, setCode] = useState("");
  const {
    mutate: verifyToken,
    isPending,
    isError,
  } = useVerifyLoginCode({
    onSuccess: async (data) => {
      saveLoginToken(data);
      await navigate("/");
    },
    onError: (error) => {
      console.error("Verification failed", error);
    },
  });

  const handleComplete = (value: string) => {
    setCode(value);
    verifyToken({ verifyCodeRequest: { companyId, code: value } });
  };

  return (
    <Container>
      <VStack spacing={4}>
        <Text>{t("verify_token.email_sent")}</Text>
        <HStack>
          <PinInput otp onComplete={handleComplete}>
            <PinInputField />
            <PinInputField />
            <PinInputField />
            <PinInputField />
            <PinInputField />
            <PinInputField />
          </PinInput>
        </HStack>
        {isError && <Text color="red.500">{t("verify_token.error")}</Text>}
        <Button isLoading={isPending} onClick={() => handleComplete(code)}>
          {t("verify_token.verify_button")}
        </Button>
      </VStack>
    </Container>
  );
}
